import React, { useState } from 'react';
import NestedField from './NestedField';

const SiteArray = ({ sites, onChange, editable = true }) => { // Default editable to true
  const [collapsed, setCollapsed] = useState(sites.map(() => true));

  const handleSiteChange = (index, updatedSite) => {
    const newSites = [...sites];
    newSites[index] = updatedSite;
    onChange(newSites); // Removed 'Sites' prefix
  };

  const handleSiteRemove = (index) => {
    const newSites = sites.filter((_, i) => i !== index);
    onChange(newSites); // Removed 'Sites' prefix
    setCollapsed(collapsed.filter((_, i) => i !== index));
  };

  const toggleCollapse = (index) => {
    const newCollapsed = [...collapsed];
    newCollapsed[index] = !newCollapsed[index];
    setCollapsed(newCollapsed);
  };

  const addSite = () => {
    onChange([
      ...sites,
      {
        Name: '',
        ControlChannel: '',
        VoiceChannels: [],
        Location: { X: '', Y: '', Z: '' },
        SystemID: '',
        SiteID: '',
        Range: 0
      }
    ]); // Removed 'Sites' prefix
    setCollapsed([...collapsed, true]);
  };

  return (
    <div className="site-array">
      <h3>Sites</h3>
      {sites.map((site, index) => (
        <div key={index} className="site-item">
          <h4>
            <button type="button" onClick={() => toggleCollapse(index)}>
              {collapsed[index] ? `Show ${site.Name || `Site ${index + 1}`}` : `Hide ${site.Name || `Site ${index + 1}`}`}
            </button>
            <button type="button" onClick={() => handleSiteRemove(index)} style={{ marginLeft: '10px', color: 'red' }}>
              Remove
            </button>
          </h4>
          {!collapsed[index] && (
            <NestedField
              name={site.Name || `Site ${index + 1}`}
              value={site}
              onChange={(field, value) => 
                handleSiteChange(index, { ...site, [field]: value })
              }
              editable={editable} // Pass editable prop
            />
          )}
        </div>
      ))}
      <button type="button" onClick={addSite} disabled={!editable}> {/* Disable add button if not editable */}
        Add New Site
      </button>
    </div>
  );
};

export default SiteArray;
